"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Root = styled_1.default.div `
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: space-between;
  overflow: hidden;
`;
const Content = styled_1.default.div `
  position: relative;
  flex: 1;
  overflow: hidden;
`;
const StartEnd = styled_1.default.div `
  position: relative;
  flex: 0;
`;
const Page = ({ className, slotStart, children, slotEnd, direction = 'column', }) => {
    return ((0, jsx_runtime_1.jsxs)(Root, { className: className, direction: direction, children: [slotStart && (0, jsx_runtime_1.jsx)(StartEnd, { children: slotStart }), (0, jsx_runtime_1.jsx)(Content, { children: children }), slotEnd && (0, jsx_runtime_1.jsx)(StartEnd, { children: slotEnd })] }));
};
exports.Page = Page;
